import { useEffect } from 'react';
import { TabNode } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { CodeNode } from '@lexical/code';
import { TableNode } from '@lexical/table';
import { HeadingNode } from '@lexical/rich-text';
import { ListNode } from '@lexical/list';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import {
  $stripLink,
  $flattenTable,
  $codeBlockToParagraph,
  $horizontalRuleToParagraph,
  $tabToSpaces,
  $headingToToolbarLevel,
  $checklistToBullets,
} from './docTransforms';

/** Keeps the editor's document inside what its toolbar can express: links are
 *  stripped to plain text, pasted tables, code blocks and horizontal rules
 *  become paragraphs, tabs become spaces, H4–H6 become H3 and checklists become
 *  bulleted lists. Node transforms run on every mutation, so paste, drop,
 *  typing and programmatic inserts are all covered. */
export function DocHygienePlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(
    () =>
      mergeRegister(
        editor.registerNodeTransform(LinkNode, $stripLink),
        editor.registerNodeTransform(AutoLinkNode, $stripLink),
        editor.registerNodeTransform(TableNode, $flattenTable),
        editor.registerNodeTransform(CodeNode, $codeBlockToParagraph),
        editor.registerNodeTransform(HorizontalRuleNode, $horizontalRuleToParagraph),
        editor.registerNodeTransform(TabNode, $tabToSpaces),
        editor.registerNodeTransform(HeadingNode, $headingToToolbarLevel),
        editor.registerNodeTransform(ListNode, $checklistToBullets),
      ),
    [editor],
  );
  return null;
}
